import(/* webpackMode: "eager" */ "/codebuild/output/src690167431/src/pixelated-tech/apps/amava-janitorial/src/app/global-error.tsx");
